export default __webpack_public_path__ + "static/media/ezclothing-white.f11567fe.svg";